import { useState } from "react";
import { Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { Chat, Home } from "@mui/icons-material";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import OrgIcon from "@mui/icons-material/Business";
import CheckBoxOutlineBlankSharpIcon from "@mui/icons-material/CheckBoxOutlineBlankSharp";
import CheckBoxSharpIcon from "@mui/icons-material/CheckBoxSharp";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import InviteIcon from "@mui/icons-material/ForwardToInbox";
import PatientPortalIcon from "@mui/icons-material/Healing";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import CreatorIcon from "@mui/icons-material/ManageAccounts";
import MenuIcon from "@mui/icons-material/Menu";
import SettingsIcon from "@mui/icons-material/Settings";
import UserIcon from "@mui/icons-material/SettingsAccessibility";
import { Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import { useTheme } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import { Auth } from "aws-amplify";
import { useSnackbar } from "notistack";
import { v4 as uuid } from "uuid";

import InviteDialog from "../../components/dialogs/inviteDialog";

import constants from "../../assets/constants";
import * as OmniDataAPI from "../../data/omniDataAPI";
import * as AdminSessionActions from "../../state/redux/adminSession";
import * as CreationActions from "../../state/redux/creatorSession";
import * as PartnerSessionActions from "../../state/redux/partnerSession";
import * as PatientSessionActions from "../../state/redux/patientSession";
import * as ProviderSessionActions from "../../state/redux/providerSession";
import * as UserSessionActions from "../../state/redux/userSession";
import { deepCopyObject } from "../../utils/helpers";
import AssessmentWizardDialog from "../dialogs/assessmentWizardDialog";
import OrganizationDialog from "../dialogs/organizationDialog";
import UserDialog from "../dialogs/userDialog";
import AppBarIconButton from "./appBarIconButton";
import OmniMenu from "./omniMenu";

const PortalAvatar = props => {
  const { userODM, awsGroup, patientODM, organizationODM } = props;

  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState(null);

  const { enqueueSnackbar } = useSnackbar();

  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    Auth.signOut().then(() => window.location.reload());
    props.setShowSettingsRequest(false);
  };

  const [newInvite, setNewInvite] = useState(null);

  const [editUserODM, setEditUserODM] = useState(null);
  const [editOrganizationODM, setEditOrganizationODM] = useState(null);
  const [showAssessmentDialog, setShowAssessmentDialog] = useState(null);

  return (
    <Fragment>
      <Tooltip title={"Settings"}>
        <>
          <AppBarIconButton
            size="large"
            edge="start"
            color="inherit"
            id="omni-avatar-menu-button"
            aria-controls={open ? "omni-avatar-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={e => handleClick(e)}
          >
            <Avatar
              key={uuid()}
              fontSize="large"
              alt={"?"}
              sx={{
                background: theme.palette.primary.contrastText,
              }}
            >
              {!open ? (
                <MenuIcon
                  sx={{
                    color: theme.palette.secondary.main,
                  }}
                />
              ) : (
                <CloseRoundedIcon
                  sx={{
                    color: theme.palette.secondary.main,
                  }}
                />
              )}
            </Avatar>
          </AppBarIconButton>
        </>
      </Tooltip>
      <OmniMenu
        id="omni-avatar-menu"
        MenuListProps={{
          "aria-labelledby": "omni-avatar-menu-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {/* ///////////////// Creator Nav (DEMO) //////////////////// */}
        <Typography
          variant="body1"
          sx={{
            paddingLeft: theme.spacing(1),
            fontWeight: 600,
            display: awsGroup === constants.userGroups.Creator ? "flex" : "none",
          }}
        >
          Demo Portals
        </Typography>
        <MenuItem
          key={uuid()}
          sx={{
            display: awsGroup === constants.userGroups.Creator ? "flex" : "none",
          }}
          onClick={() => {
            props.history.push(constants.appPaths.appPathCreator);
            handleClose();
          }}
        >
          <ListItemIcon>
            <CreatorIcon fontSize="small" key={uuid()} />
          </ListItemIcon>
          <ListItemText>Creator Portal</ListItemText>
        </MenuItem>

        <MenuItem
          key={uuid()}
          sx={{
            display: awsGroup === constants.userGroups.Creator ? "flex" : "none",
          }}
          onClick={() => {
            props.history.push(constants.appPaths.appPathCreatorDemoPatient);
            handleClose();
          }}
        >
          <ListItemIcon>
            <PatientPortalIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Patient Portal</ListItemText>
        </MenuItem>
        {/* <MenuItem
          sx={{
            display: awsGroup === constants.userGroups.Creator ? "flex" : "none",
          }}
          onClick={() => {
            props.history.push(constants.appPaths.appPathCreatorDemoTrials);
            handleClose();
          }}
        >
          <ListItemIcon>
            <TrialIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Trial Management</ListItemText>
        </MenuItem> */}
        {/* <MenuItem
          sx={{
            display: awsGroup === constants.userGroups.Creator ? "flex" : "none",
          }}
          onClick={() => {
            props.history.push(constants.appPaths.appPathCreatorDemoNMHA);
            handleClose();
          }}
        >
          <ListItemIcon>
            <NMHAIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>FFC Map</ListItemText>
        </MenuItem> */}
        <Divider
          sx={{
            display: awsGroup === constants.userGroups.Creator ? "flex" : "none",
          }}
        />

        {/* ///////////////// Botpress Info//////////////////// */}

        <MenuItem
          sx={{
            display:
              organizationODM?.omniData?.organizationType ===
              constants.organizationTypeEnums.botpressTesting
                ? "flex"
                : "none",
          }}
          onClick={() => {
            props.history.push("/");
            handleClose();
          }}
        >
          <ListItemIcon>
            <Home fontSize="small" />
          </ListItemIcon>
          <ListItemText>AI Overview</ListItemText>
        </MenuItem>

        <MenuItem
          sx={{
            display:
              organizationODM?.omniData?.organizationType ===
              constants.organizationTypeEnums.botpressTesting
                ? "flex"
                : "none",
          }}
          onClick={() => {
            if (awsGroup === constants.userGroups.Administrator) {
              props.history.push(constants.appPaths.appPathAdminBotpressConversations);
            } else if (awsGroup === constants.userGroups.Provider) {
              props.history.push(constants.appPaths.appPathProviderBotpressConversations);
            } else if (awsGroup === constants.userGroups.Partner) {
              props.history.push(constants.appPaths.appPathPartnerBotpressConversations);
            }
            handleClose();
          }}
        >
          <ListItemIcon>
            <Chat fontSize="small" />
          </ListItemIcon>
          <ListItemText>Conversations</ListItemText>
        </MenuItem>

        <MenuItem
          sx={{
            display:
              organizationODM?.omniData?.organizationType ===
              constants.organizationTypeEnums.botpressTesting
                ? "flex"
                : "none",
          }}
          onClick={() => {
            if (awsGroup === constants.userGroups.Administrator) {
              props.history.push(constants.appPaths.appPathAdminBotpressTestHarness);
            } else if (awsGroup === constants.userGroups.Provider) {
              props.history.push(constants.appPaths.appPathProviderBotpressTestHarness);
            } else if (awsGroup === constants.userGroups.Partner) {
              props.history.push(constants.appPaths.appPathPartnerBotpressTestHarness);
            }
            handleClose();
          }}
        >
          <ListItemIcon>
            <AssignmentRoundedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Test Harness</ListItemText>
        </MenuItem>

        <Divider
          sx={{
            display:
              organizationODM != null &&
              organizationODM?.omniData?.organizationType ===
                constants.organizationTypeEnums.botpressTesting
                ? "flex"
                : "none",
          }}
        />

        {/* ///////////////// PATIENT SELECTION (DEMO) //////////////////// */}
        <Typography
          variant="body1"
          sx={{
            paddingLeft: theme.spacing(1),
            fontWeight: 600,
            display: awsGroup === constants.userGroups.Creator ? "flex" : "none",
          }}
        >
          Demo Patients
        </Typography>
        <MenuItem
          key={uuid()}
          sx={{
            display: awsGroup === constants.userGroups.Creator ? "flex" : "none",
          }}
          onClick={() => {
            props.loadPatientODMRequest(constants.demoUserId.userOne);
            handleClose();
          }}
        >
          <ListItemIcon>
            {patientODM && patientODM._id === constants.demoUserId.userOne && (
              <CheckBoxSharpIcon fontSize="small" />
            )}
            {patientODM != null && patientODM._id !== constants.demoUserId.userOne && (
              <CheckBoxOutlineBlankSharpIcon fontSize="small" />
            )}
          </ListItemIcon>
          <ListItemText>Linda #1</ListItemText>
        </MenuItem>
        <MenuItem
          key={uuid()}
          sx={{
            display: awsGroup === constants.userGroups.Creator ? "flex" : "none",
          }}
          onClick={() => {
            props.loadPatientODMRequest(constants.demoUserId.userTwo);
            handleClose();
          }}
        >
          <ListItemIcon>
            {patientODM && patientODM._id === constants.demoUserId.userTwo && (
              <CheckBoxSharpIcon fontSize="small" />
            )}
            {patientODM !== null && patientODM._id !== constants.demoUserId.userTwo && (
              <CheckBoxOutlineBlankSharpIcon fontSize="small" />
            )}
          </ListItemIcon>
          <ListItemText>Linda #2</ListItemText>
        </MenuItem>
        <MenuItem
          key={uuid()}
          sx={{
            display: awsGroup === constants.userGroups.Creator ? "flex" : "none",
          }}
          onClick={() => {
            props.loadPatientODMRequest(constants.demoUserId.userThree);
            handleClose();
          }}
        >
          <ListItemIcon>
            {patientODM && patientODM._id === constants.demoUserId.userThree && (
              <CheckBoxSharpIcon fontSize="small" />
            )}
            {patientODM !== null && patientODM._id !== constants.demoUserId.userThree && (
              <CheckBoxOutlineBlankSharpIcon fontSize="small" />
            )}
          </ListItemIcon>
          <ListItemText>Linda #3</ListItemText>
        </MenuItem>
        <MenuItem
          key={uuid()}
          sx={{
            display: awsGroup === constants.userGroups.Creator ? "flex" : "none",
          }}
          onClick={() => {
            props.loadPatientODMRequest(constants.demoUserId.userFour);
            handleClose();
          }}
        >
          <ListItemIcon>
            {patientODM && patientODM._id === constants.demoUserId.userFour && (
              <CheckBoxSharpIcon fontSize="small" />
            )}
            {patientODM !== null && patientODM._id !== constants.demoUserId.userFour && (
              <CheckBoxOutlineBlankSharpIcon fontSize="small" />
            )}
          </ListItemIcon>
          <ListItemText>Mae #1</ListItemText>
        </MenuItem>
        <Divider
          sx={{
            display: awsGroup === constants.userGroups.Creator ? "flex" : "none",
          }}
        />
        {/* /////////////////// Start Email Support ////////////////// */}
        {/* <MenuItem
          sx={{
            display: awsGroup === constants.userGroups.Administrator ? "flex" : "none",
          }}
          onClick={() => {
            //props.history.push(constants.appPaths.appPathAdminOrganization);
            // handleClose();

            //===================================================================

            // let command = new CreateTemplateCommand(input);
            //   command = new UpdateTemplateCommand(input);

            // const input = {
            //   TemplateName: "Dev_Administrator_Template_v1",
            // };

            // // works
            // let theHTML = `'<p>Greetings,<br><br>Welcome aboard! Your username is {{name}}.<br><br>Please use this link to reset your password <a href="https://test.omnisciahealth.coach/?userName={{name}}&resetPassword=true">test.omnisciahealth.coach </a><span style="display: none;">{####}</span>    <br>  <br> - Empire OS and Omniscia Health</p>`;

            // PROTOTYPE
            let theHTML = `<p>Welcome {{displayname}},<br /><br />A {{usertype}} account has been setup for you.<br />Your username is: {{name}}.<br /><br /><a href="https://test.omnisciahealth.coach/?userName={{name}}&resetPassword=true">Please click here to confirm your account and choose a new password.</a><span style="display: none">{####}</span><br /><br />- The Omniscia Health Team<br /><br />(Test Silo)<br /></p>`;

            const input = {
              Template: {
                TemplateName: "Test_Provider_Template_v1",
                SubjectPart: "Welcome Aboard",
                HtmlPart: theHTML,
                TextPart: "",
              },
            };

            // let command = new CreateTemplateCommand(input);
            let command = new UpdateTemplateCommand(input);

            sesClient
              .send(command)
              .then(response => {
                console.log(response);


                ////////////////////////////////////////////////////
                // const input = {
                //   Template: {
                //     TemplateName: response.Template.TemplateName,
                //     SubjectPart: response.Template.SubjectPart,
                //     HtmlPart: theHTML,
                //     TextPart: response.Template.TextPart,
                //   },
                // };

                // let command = new UpdateTemplateCommand(input);

                // sesClient
                //   .send(command)
                //   .then(response => {})
                //   .catch(error => {
                //     enqueueSnackbar(`SESClient Error: ${error})`, {
                //       variant: "error",
                //     });
                //     console.log(error);
                //   });
                /////////////////////////////////////////////////////////////
              })
              .catch(error => {
                enqueueSnackbar(`SESClient Error: ${error})`, {
                  variant: "error",
                });
                console.log(error);
              });

            return;
            //===================================================================
          }}
        >
          <ListItemIcon>
            <InviteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Template POC</ListItemText>
        </MenuItem> */}
        {/* /////////////////// END Email Support ////////////////// */}

        {/* /////////////////// ADMIN OPTIONS ////////////////// */}
        <MenuItem
          key={uuid()}
          sx={{
            display: awsGroup === constants.userGroups.Administrator ? "flex" : "none",
          }}
          onClick={() => {
            props.history.push(constants.appPaths.appPathAdminInvite);
            handleClose();
          }}
        >
          <ListItemIcon>
            <InviteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Invites</ListItemText>
        </MenuItem>
        <Divider
          sx={{
            display: awsGroup === constants.userGroups.Administrator ? "flex" : "none",
          }}
        />

        {/* <Typography
          variant="body1"
          sx={{
            paddingLeft: theme.spacing(1),
            fontWeight: 300,
            display:
              organizationODM != null &&
              organizationODM.omniData.organizationType === constants.organizationTypeEnums.nsight
                ? "flex"
                : "none",
          }}
        >
          Assessments
        </Typography>
        <MenuItem
          key={uuid()}
          sx={{
            display:
              organizationODM != null &&
              organizationODM.omniData.organizationType === constants.organizationTypeEnums.nsight
                ? "flex"
                : "none",
          }}
          onClick={() => {
            setShowAssessmentDialog(constants.assessmentIDs.omniHealthHistory);
            handleClose();
          }}
          disabled={props.showSettings}
        >
          <ListItemIcon>
            <AssignmentRoundedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Health History</ListItemText>
        </MenuItem>
        <Divider
          sx={{
            display:
              organizationODM != null &&
              organizationODM.omniData.organizationType === constants.organizationTypeEnums.nsight
                ? "flex"
                : "none",
          }}
        />
        <Typography
          variant="body1"
          sx={{
            paddingLeft: theme.spacing(1),
            fontWeight: 300,
            display:
              organizationODM != null &&
              organizationODM.omniData.organizationType === constants.organizationTypeEnums.nsight
                ? "flex"
                : "none",
          }}
        >
          Profile
        </Typography>
        <MenuItem
          key={uuid()}
          sx={{
            display:
              organizationODM != null &&
              organizationODM.omniData.organizationType === constants.organizationTypeEnums.nsight
                ? "flex"
                : "none",
          }}
          onClick={() => {
            setShowAssessmentDialog(constants.assessmentIDs.omniHealthHistoryDemo);
            handleClose();
          }}
          disabled={props.showSettings}
        >
          <ListItemIcon>
            <UserIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Update Info</ListItemText>
        </MenuItem>
        <Divider
          sx={{
            display:
              organizationODM != null &&
              (organizationODM.omniData.organizationType ===
                constants.organizationTypeEnums.nsight)
                ? "flex"
                : "none",
          }}
        />*/}

        {/* /////////////////// USER OPTIONS ////////////////// */}
        <MenuItem
          key={uuid()}
          sx={{
            display: awsGroup === constants.userGroups.Administrator ? "flex" : "none",
          }}
          onClick={() => {
            setEditOrganizationODM(organizationODM);
            handleClose();
          }}
          disabled={organizationODM == null}
        >
          <ListItemIcon>
            <OrgIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Organization</ListItemText>
        </MenuItem>
        <MenuItem
          key={uuid()}
          sx={{
            display: userODM ? "flex" : "none",
          }}
          onClick={() => {
            setEditUserODM(userODM);
            handleClose();
          }}
          disabled={userODM == null}
        >
          <ListItemIcon>
            <UserIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>My Info</ListItemText>
        </MenuItem>
        <MenuItem
          key={uuid()}
          onClick={() => {
            props.setShowSettingsRequest(true);
            handleClose();
          }}
          disabled={props.showSettings}
        >
          <ListItemIcon>
            <SettingsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Settings</ListItemText>
        </MenuItem>

        {/* /////////////////// LOGOUT ////////////////// */}
        <Divider
          sx={{
            display: "flex",
          }}
        />
        <MenuItem
          key={uuid()}
          onClick={() => {
            handleLogout();
            handleClose();
          }}
          disabled={props.showSettings}
        >
          <ListItemIcon>
            <LogoutRoundedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </OmniMenu>
      {newInvite && (
        <InviteDialog
          open={newInvite != null}
          omniODM={newInvite}
          onAccept={modifiedInvite => {
            OmniDataAPI.createInvite(modifiedInvite).then(response => {
              if (response != null) {
                enqueueSnackbar("Invite Created Successfully.", {
                  variant: "success",
                });
                props.reflectUpdatedInviteODMRequest(response);
              } else {
                enqueueSnackbar("Invite Creation Failed!", {
                  variant: "error",
                });
              }
            });

            setNewInvite(null);
          }}
          onClose={() => {
            setNewInvite(null);
          }}
        />
      )}
      {editUserODM && (
        <UserDialog
          open={editUserODM != null}
          dialogTitle={"Edit Information"}
          omniODM={deepCopyObject(editUserODM)}
          tabId={
            organizationODM.omniData.organizationType === constants.organizationTypeEnums.nsight
              ? 1
              : 0
          }
          organizationType={organizationODM.omniData.organizationType}
          onAccept={user => {
            if (awsGroup === constants.userGroups.Partner) {
              props.updatePartnerRequest(user);
            } else if (awsGroup === constants.userGroups.Provider) {
              props.updateProviderRequest(user);
            } else if (awsGroup === constants.userGroups.Administrator) {
              props.updateAdministratorRequest(user);
            }

            setEditUserODM(null);
          }}
          onClose={() => {
            setEditUserODM(null);
          }}
        />
      )}
      {editOrganizationODM && (
        <OrganizationDialog
          open={editOrganizationODM != null}
          dialogTitle={"Edit Organization"}
          omniDMO={deepCopyObject(editOrganizationODM)}
          fullWidth={true}
          onAccept={selectedOrganization => {
            props.updateOrganizationRequest(selectedOrganization);
            setEditOrganizationODM(null);
          }}
          onClose={() => {
            setEditOrganizationODM(null);
          }}
        />
      )}
      {showAssessmentDialog != null && (
        <AssessmentWizardDialog
          dialogTitle={"A.I. Assessment"}
          botpressAssessment={true}
          open={showAssessmentDialog != null}
          lockAssessmentOmniType={showAssessmentDialog}
          autoStartAssessment={false}
          lockSubjectODM={props.proxyPatientODM}
          onAccept={() => {
            setShowAssessmentDialog(null);
          }}
          onClose={() => {
            setShowAssessmentDialog(null);
          }}
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = state => ({
  userODM: state.userSession.userODM,
  proxyPatientODM: state.userSession.proxyPatientODM,
  organizationODM: state.userSession.organizationODM,
  awsGroup: state.userSession.awsGroup,
  showSettings: state.userSession.showSettings,
  patientODM: state.patientSession.patientODM,
});

const mapDispatchToProps = {
  setShowSettingsRequest: UserSessionActions.setShowSettingsRequest,
  reflectUpdatedInviteODMRequest: AdminSessionActions.reflectUpdatedInviteODMRequest,
  updatePartnerRequest: PartnerSessionActions.updatePartnerRequest,
  updateProviderRequest: ProviderSessionActions.updateProviderRequest,
  updateAdministratorRequest: AdminSessionActions.updateAdministratorRequest,
  loadPatientODMRequest: PatientSessionActions.loadPatientODMRequest,
  updateOrganizationRequest: CreationActions.updateOrganizationRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PortalAvatar));
